import type {TacticalPlanContext} from "./TacticalPlanContext";

type TacticalPLanAnalizatorOutputType = {
    rule_id: number,
    vehicle_id: number|null,
    type: 'rule_id' | 'zone_id',
    id: number,
}


export class TacticalPlanAnalizator {

    public findWhereIsUsedThisVehicleId(vehicle_id: number|null, context: TacticalPlanContext): TacticalPLanAnalizatorOutputType[] {
        let {tp, tprules, zones, tpZoneLists, currentRuleId} = context.getContext();
        let output: TacticalPLanAnalizatorOutputType[] = [];

        tprules.forEach( rule => {
            let ruleId = rule.getId();
            if (ruleId!==null && rule.getRule().details.action.type === 'vehicle' && rule.getRule().details.action.vehicle_id === vehicle_id) {
                output.push({rule_id: ruleId, vehicle_id: vehicle_id, type: 'rule_id', id: ruleId});
            }
        });

        tprules.forEach( rule => {
            let ruleId = rule.getId();
            if (ruleId!==null && rule.getRule().details.vehicle_id === vehicle_id) {
                output.push({rule_id: ruleId, vehicle_id: vehicle_id, type: 'rule_id', id: ruleId});
            }
        })

        let currentZoneListMapId = tprules.find(rule => rule.getId() === currentRuleId)?.getMapId() ?? -1;
        zones.forEach( zone => {
            // don`t get map from zones, bcs we need this map from tpZoneLists
            if (zone.vehicle_id === vehicle_id && currentZoneListMapId !== zone.map_id) {
                output.push({rule_id: zone.map_id, vehicle_id: vehicle_id, type: 'zone_id', id: zone.id});
            }
        });

        tpZoneLists.forEach( zoneList => {
            if (zoneList.mapId === currentZoneListMapId)    {
                zoneList.zoneList.forEach( zone => {
                    if (zone.vehicle_id === vehicle_id) {
                        output.push({rule_id: zoneList.ruleId, vehicle_id: vehicle_id, type: 'zone_id', id: zone.id ?? -1});
                    }
                });
            }
        });

        return output;
    }

    // public getAlreadyUsedVehicles(context: TacticalPlanContext): number[] {
    //     let {tp, tprules, zones, tpZoneLists} = context.getContext();
    //     let vehiclesInAllRules = zones
    //         .filter(zone=>zone.vehicle_id!==null)
    //         .map((zone) => zone.vehicle_id);
    //     vehiclesInAllRules = [...vehiclesInAllRules, ...tprules.filter(rule => rule.getRule().details.action.type === 'vehicle').map(rule => rule.getRule().details.action.vehicle_id)]
    //     return vehiclesInAllRules as number[];
    // }

    public getAlreadyUsedVehicles(context: TacticalPlanContext): number[] {
        let {tp, tprules, zones, tpZoneLists, currentRuleId} = context.getContext();

        let vehiclesFromActionVehicles = tprules.filter(rule => rule.getRule().details.action.type === 'vehicle').map(rule => rule.getRule().details.action.vehicle_id);

        // let currentMapId = tprules.find(rule => rule.getId() === currentRuleId)?.getMapId() ?? -1;
        let vehiclesFromZoneList = [];
        // if (currentMapId!==-1) { // if active rule is map type, get vehicles from zones
        //     let tpZoneListsMapId = tpZoneLists.find(zoneList => zoneList.ruleId === currentRuleId)?.mapId ?? -1;
        //     // get vehicles from zones of current map (current rule)
        //     vehiclesFromZoneList = tpZoneLists.find(zoneList => zoneList.ruleId === currentRuleId)?.zoneList.filter(zone => zone.vehicle_id !== null).map(zone => zone.vehicle_id) ?? [];
        // } else {
            // get all vehicles from all zones
        vehiclesFromZoneList = tpZoneLists.map(zoneList => zoneList.zoneList.filter(zone => zone.vehicle_id !== null).map(zone => zone.vehicle_id)).flat();
        // }

        // let vehiclesFromZonesExceptCurrentZoneMapId = zones.filter(zone => zone.vehicle_id !== null && tpZoneListsMapId !== zone.map_id).map(zone => zone.vehicle_id);

        let vehiclesFromDetails = tprules.filter(rule => rule.getRule().details.vehicle_id !== null).map(rule => rule.getRule().details.vehicle_id);

        let vehiclesInAllRules = [...vehiclesFromActionVehicles, ...vehiclesFromZoneList, ...vehiclesFromDetails];

        vehiclesInAllRules = vehiclesInAllRules.filter(vehicle => vehicle !== null);

        return vehiclesInAllRules as number[];
    }

}